// Keep these presentation rules aligned with backend/access.py. Every API
// continues to enforce its own permissions, including direct links and chat.
export function moduleAllowed(user, cabinet, module) {
  if (user?.platform_role === "super_admin") return true;
  const canonical = (role) => ({ partner: "associe", staff: "collaborator" }[role] || role);
  const role = canonical(user?.role);
  const custom = cabinet?.custom_roles?.find((entry) => entry.key === role);
  if (custom) return (custom.modules || []).includes(module);
  const configured = cabinet?.module_roles?.[module];
  return configured ? configured.map(canonical).includes(role) : ["ceo", "associe", "admin", "collaborator"].includes(role);
}

export const WORKSPACE_GROUPS = [
  { id: "dossier", label: "Dossier & pièces", tabs: ["profile", "documents", "portal"] },
  { id: "pilotage", label: "Suivi des travaux", tabs: ["work", "calendar", "preparation", "team"] },
  { id: "compta", label: "Comptabilité", tabs: ["invoices", "bank", "tiers", "fec", "depreciation", "cutoff", "revision"] },
  { id: "fiscal", label: "Fiscalité & comptes", tabs: ["vat", "is", "annual_accounts"] },
  { id: "social", label: "Social & paie", tabs: ["payroll", "payroll_period", "payslips", "payroll_bundle", "rgdu", "leave", "accrual", "sickness"] },
  { id: "livraison", label: "Échanges de fichiers", tabs: ["accounting_exports", "exchanges"] },
];
const ACCOUNTING = ["invoices","accounting_exports","preparation", "revision", "is", "depreciation", "cutoff", "vat", "annual_accounts"];
const SOCIAL = WORKSPACE_GROUPS.find((group) => group.id === "social").tabs;
export function tabAllowed(tab, user, cabinet) {
  const can = (module) => moduleAllowed(user, cabinet, module);
  if (!can("clients")) return false;
  if (ACCOUNTING.includes(tab)) return can("liasse");
  if (SOCIAL.includes(tab)) return can("paie");
  if (tab === "calendar") return can("echeances");
  if (tab === "work") return can("missions") || can("echeances");
  if (tab === "exchanges") return can("liasse") || can("paie");
  if (tab === "portal") return user?.platform_role === "super_admin" || ["ceo", "associe", "partner", "admin"].includes(user?.role);
  return true;
}
